<template>
<div>
      <div style="height:15px;text-align:left;margin-top:12px;font-size:14px;color:#f55;"></div>
 <el-tag  effect="dark">仅显示最新10条发件箱消息</el-tag>&nbsp;&nbsp;&nbsp; <el-button type="warning" size="small" style="margin-right:10px" @click="userlist()">返回</el-button>
  <el-table
    :data="tableData"
    stripe
    border
    height="700px">
    <el-table-column
      prop="SendedTime"
      label="发送时间"
      width="100">
    </el-table-column>
    
    <el-table-column
      prop="GSMContent"
      label="短信内容">
    </el-table-column>
  </el-table>
</div>
</template>
<script>

// import elTableInfiniteScroll from 'el-table-infinite-scroll';
import {restbase} from '../rest'
export default {
data() {
    return {
        tableData: [],
        Mobile:''
    }
},
 created(){
     this.Mobile=JSON.parse(sessionStorage.getItem('Mobile')); //获取所有关系
     this.fetchData();
 },
   methods: {
        fetchData() {
                 this.tableData=[];
                 this.$http.post(restbase() + "asp/GetYBMessage", {
                    Mobile: this.Mobile
                }).then(response=>{
                   this.loading=false;
                    console.log(response.data.d);
                    const d = JSON.parse('['+response.data.d.replace(/\r|\n/ig,'')+']');
                    console.log(d);
                    this.tdsdata = [];
                    d.forEach(e => {
                      this.tableData.push({SendedTime:e.SendedTime, TelNum:e.TelNum, GSMContent:e.GSMContent});
                        
                    });
                    console.log(this.tableData);
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
             },
             userlist(){
                 //清空前一个人的定制数据
                        sessionStorage.removeItem("Mobile");
                        this.$router.push('YBMember');
             }
   }
}
</script>
<style scoped>
.el-table {
  width: 100%;
}
</style>